<template>
  <div class="splitHeader d-flex flex-column">
    <transition>
      <section :style="{height: `${viewPort.height / 2}px`}" v-if="currentSection === null || currentSection === section.howTO">
        <seo-v-img :height="viewPort.height / 2" width="100vw" class="absolute" :src="lowerImage"/>
        <div class="fill-height d-flex flex-column justify-end align-start">
          <h1 class="mb-3">{{howToTitle}}</h1>
          <h4 class="mb-4">{{howToSubtitle}}</h4>
          <transition>
            <DiscoverButton high-visibility v-if="!currentSection" class="cta animated" :to="{params: {internal: section.howTO}}" />
          </transition>
        </div>
      </section>
    </transition>
    <transition>
      <section :style="{height: `${viewPort.height / 2}px`}" v-if="currentSection === null || currentSection === section.consciuousDesigner">
        <seo-v-img :height="viewPort.height / 2" width="100vw" class="absolute" :src="upperImage"/>
        <div class="fill-height d-flex flex-column justify-end align-start">
          <h1 class="mb-3">{{designerConsciusTitle}}</h1>
          <transition>

            <DiscoverButton high-visibility v-if="!currentSection" class="cta animated" :to="{params: {internal: section.consciuousDesigner}}" />
          </transition>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import upperImage from '@/assets/img/bush.jpg'
import lowerImage from '@/assets/img/elephant.jpg'
import Section from '@/constants/responsabilitySection'
import DiscoverButton from '@/atoms/DiscoverButton'
import { Viewport } from '@monogrid/vue-lib'

export default {
  name: 'SplitHeader',
  mixins: [Viewport],
  components: {
    DiscoverButton
  },
  props: {
    currentSection: {
      type: String,
      default: null
    },
    howToTitle: {
      type: String
    },
    howToSubtitle: {
      type: String
    },
    designerConsciusTitle: {
      type: String
    }
  },
  data () {
    return {
      upperImage,
      lowerImage,
      section: Section
    }
  }
}
</script>

<style scoped lang="scss">
  .absolute {
    position: absolute !important;
    top: 0;
    left: 0;
  }

  .splitHeader {
    section {
      position: relative;
      width: 100vw;
      padding: 20px;

      h1 {
        position: relative;
        font-size: 1.5rem;
        color: #fff;
      }

      h4 {
        font-size: 1.2rem;
        line-height: 1.5;
        color: #fff;
        z-index: 100;
      }
    }
  }
</style>
